import type {FC} from "react";
import {memo} from "react";
import {
    Badge,
    CardBody,
    CardContent,
    CardHeader,
    CardImage,
    CardTitle,
    Period,
    StyledCard,
    CardContentItem,
} from "./card.styles";
import type {CardProps} from "./card.types";
import {ReactComponent as Check} from "@src/core/icons/check_large.svg";
import {Button} from "@src/components";

export const Card: FC<CardProps> = memo(
    ({
         title,
         badgeText,
         badgeColor,
         src,
         period,
         api,
         requests,
         buttonText,
         handleButton
     }) => {

        const handleButton2 = () => {
            if (10 === handleButton) {
                return window.location.replace('/#price');
            } else {
                return window.location.replace('/order/pay/'+handleButton);
            }
        }

        return (
            <StyledCard>
                <CardHeader>
                    <CardTitle>{title}</CardTitle>
                    <Badge badgeColor={badgeColor}>{badgeText}</Badge>
                </CardHeader>
                <CardBody>
                    <CardImage url={src}/>
                    <Period>{period}</Period>
                    <CardContent>
                        <CardContentItem>
                            <Check/>
                            <div>{api} API методов</div>
                        </CardContentItem>
                        <CardContentItem>
                            <Check/>
                            {requests} Запросов в минуту
                        </CardContentItem>
                    </CardContent>
                    <Button onClick={handleButton2} text={buttonText} borderradius="XXXL" variant="label" type="submit"/>
                </CardBody>
            </StyledCard>
        );
    }
);
